import ButtonIconSmall from '../../../components/button-icon-small.component';
import { RemoveRedEye } from '@mui/icons-material';
import { getDateLocalMX } from '../../../utils/dates';
import { ITask } from '../../../interfaces/project.interface';
import { getRoutineDescriptionByType } from '../../../utils/get-title-routines';
import { ITypeRoutine } from '../../../constants/routines.constants';

export const tasksAdapter = (
	data: ITask[],
	viewDetails: (item: ITask) => void
): ITask[] => {
	const tasks: ITask[] = data.map((task: ITask) => {
		return {
			...task,
			descriptionCustom: getRoutineDescriptionByType(
				task.type as keyof ITypeRoutine,
				task.executionDate as unknown as Date
			),
			date: getDateLocalMX(task.executionDate),
			assignedTo: task.supervisorName || task.teamName,
			acciones: (
				<ButtonIconSmall
					text="Ver"
					type="info"
					icon={<RemoveRedEye />}
					style={{ fontSize: '10px' }}
					onPress={() => viewDetails(task)}
				/>
			),
		};
	});
	return tasks;
};
